import { ExclusionQuery } from '../api';

function positiveInteger(value: string | null): number | undefined {
  if (!value || !/^\d+$/.test(value)) return undefined;
  const number = Number(value);
  return Number.isSafeInteger(number) && number > 0 ? number : undefined;
}

export function readExclusionQuery(params: URLSearchParams): ExclusionQuery {
  const limit = positiveInteger(params.get('limit'));
  return {
    page: positiveInteger(params.get('page')) ?? 1,
    limit: limit && [20, 50, 100].includes(limit) ? limit : 20,
    product_item_code: positiveInteger(params.get('product_item_code')),
    plant: positiveInteger(params.get('plant')),
    distribution_channel:
      params.get('distribution_channel')?.trim() || undefined,
    cg_1_business_segmentation:
      params.get('cg_1_business_segmentation')?.trim() || undefined,
  };
}

export function writeExclusionQuery(query: ExclusionQuery): URLSearchParams {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined && value !== '') params.set(key, String(value));
  }
  return params;
}
